import { inject, Injectable } from '@angular/core';
import {doc, Firestore, getDoc} from "@angular/fire/firestore";
import { Storage } from "@angular/fire/storage";
import {BehaviorSubject} from "rxjs";
import {Functions} from "@angular/fire/functions";
import {DocumentData} from "@angular/fire/compat/firestore";
import {IAuthor} from "../common/interfaces";
import {Entries} from "bf-functions";

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  get authorsList(): BehaviorSubject<Map<string, IAuthor>> {
    return this._authorsList;
  }

  firestore: Firestore = inject(Firestore);
  storage: Storage = inject(Storage);
  functions = inject(Functions);

  private _authorsList: BehaviorSubject<Map<string, IAuthor>> = new BehaviorSubject<Map<string, IAuthor>>(new Map<string, IAuthor>());

  constructor() {
      this.loadAuthors().then((data: any) => {
        let authorsListl: Map<string, IAuthor> = new Map<string, IAuthor>();
        if (data === null) {
          console.warn('No authors cache found, loading from server');
        }
        else {
          Entries.jsonToMap(data).forEach((value: any, key: string) => {
            const id = key;
            const d = value;
            if (d?.publications > 0 || d?.forceShowInList) {
              authorsListl.set(id, {
                names: d?.['names'],
                publications: d?.['publications'],
                researchArea: d?.['researchArea'],
                country: d?.['country'],
                slug: d?.['slug']
              });
            }
          });
        }
        this._authorsList.next(authorsListl);
      });
  }

  async getPublicationsForAuthor(author_id: string): Promise<Map<string, any[]> | null> {
    const authorPublicationsCacheDocRef = doc(this.firestore, `cache/authors/byId/${author_id}`);
    const authorPublicationsCacheDoc = await getDoc(authorPublicationsCacheDocRef);
    if (authorPublicationsCacheDoc.exists()) {
      const result = Entries.jsonToMap(authorPublicationsCacheDoc.data());
      return result;
    }
    else {
      return null;
    }
  }

  private async loadAuthors(): Promise<DocumentData | null> {
    const authorsCacheDocRef = doc(this.firestore, 'cache/authors');
    const authorsCacheDoc = await getDoc(authorsCacheDocRef);
    if (authorsCacheDoc.exists()) {
      const result = authorsCacheDoc.data();
      console.log('authors cache found, returning cached data');
      return result;
    }
    else {
      console.log('authors cache not found');
      return null;
    }
  }
}
